import React from "react";
import { CustomSwitch, SwitchContainer } from "./Switch.styles";
import { SizeStyles } from "./Switch.variants";
import { useTheme } from "@mui/material";

export interface CustomVariantSwitchProps {
  size?: "sm" | "md" | "lg";
  disabled?: boolean;
  label?: string | null;
}

export const Switch = ({
  label = null,
  size = "md",
  disabled = false,
  ...rest
}: CustomVariantSwitchProps) => {
  const theme = useTheme();
  const sizeStylesFn = SizeStyles(theme);
  
  return (
    <SwitchContainer sx={{
      ...sizeStylesFn[size],
    }}>
      <CustomSwitch
        disabled={disabled}
        className="CustomSwitch"
        {...rest}
      />
      {label && 
        <span className={disabled ? "disabled" : ""}>
          {label}
        </span>}
    </SwitchContainer>
  );
};

export interface SwitchProps extends React.ComponentProps<typeof Switch> {
  as?: React.ElementType;
}

Switch.displayName = "Switch";
